import React, { useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signOut as amplifySignOut } from '@aws-amplify/auth';
import { DataContext } from "../../context/DataContext";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";

const Home = () => {
  const navigate = useNavigate();
  const { setUserData } = useContext(DataContext);

  const handleSignOut = async () => {
    try {
      await amplifySignOut();
      setUserData(null);
    } catch (e) {
      console.log(e);
    } finally {
      navigate("/login");
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-green-100 to-green-300 py-20 px-4">
          <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl font-extrabold text-gray-800 mb-4">
                Bienvenido a Sincronia Cloud
              </h1>
              <p className="text-lg text-gray-700 mb-6">
                Una startup dedicada a tu bienestar emocional. Nuestro bot terapéutico combina inteligencia artificial con principios de la terapia cognitivo-conductual para ofrecerte apoyo emocional inmediato, técnicas de manejo del estrés y una conexión empática.
              </p>
              <Link
                to="/chatroom"
                className="inline-block bg-green-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-green-700 transition"
              >
                Explora la Plataforma
              </Link>
            </div>
            <div>
              <img
                src="/sincronia_chat_robot.jpg"
                alt="Ilustración del bot de terapia"
                className="rounded-2xl shadow-lg w-full"
              />
            </div>
          </div>
        </section>

        {/* Testimonios */}
        <section className="py-16 px-4 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-10 text-gray-800">Lo que dicen nuestros usuarios</h2>
            <div className="grid gap-8 md:grid-cols-3">
              <div className="bg-green-50 p-6 rounded-lg shadow">
                <p className="italic">“SincronyBot me ayudó en un momento muy difícil. La guía que ofrece es increíble.”</p>
                <h4 className="mt-4 font-semibold">– Carla M.</h4>
              </div>
              <div className="bg-green-50 p-6 rounded-lg shadow">
                <p className="italic">“Me siento más tranquila desde que empecé a usar la app. Las técnicas de respiración son geniales.”</p>
                <h4 className="mt-4 font-semibold">– Diego R.</h4>
              </div>
              <div className="bg-green-50 p-6 rounded-lg shadow">
                <p className="italic">“¡Muy útil para el día a día! Lo recomiendo para cualquiera que quiera cuidar su salud emocional.”</p>
                <h4 className="mt-4 font-semibold">– Laura V.</h4>
              </div>
            </div>
          </div>
        </section>

        {/* Precios 
        <section className="py-16 px-4 bg-green-50">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-10 text-gray-800">Planes de Suscripción</h2>
            <div className="grid gap-8 md:grid-cols-3">
              <div className="border p-6 rounded-xl shadow-sm">
                <h3 className="text-xl font-semibold mb-4">Gratis</h3>
                <p className="text-gray-700 mb-4">Acceso limitado al bot y algunas herramientas básicas de relajación.</p>
                <p className="text-2xl font-bold mb-4">$0 / mes</p>
                <button className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700">Comenzar</button>
              </div>
              <div className="border p-6 rounded-xl shadow-sm bg-white">
                <h3 className="text-xl font-semibold mb-4">Premium</h3>
                <p className="text-gray-700 mb-4">Acceso completo al bot, estadísticas, herramientas de seguimiento y más.</p>
                <p className="text-2xl font-bold mb-4">$9.99 / mes</p>
                <button className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700">Suscribirse</button>
              </div>
              <div className="border p-6 rounded-xl shadow-sm">
                <h3 className="text-xl font-semibold mb-4">Profesional</h3>
                <p className="text-gray-700 mb-4">Ideal para psicólogos que desean integrar el bot a sus consultas.</p>
                <p className="text-2xl font-bold mb-4">$29.99 / mes</p>
                <button className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700">Unirse</button>
              </div>
            </div>
          </div>
        </section>
        */}

        {/* Preguntas Frecuentes */}
        <section className="py-16 px-4 bg-white">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-10 text-gray-800">Preguntas Frecuentes</h2>
            <div className="space-y-6">
              <div>
                <h4 className="font-semibold text-lg">¿SincronyBot reemplaza a un terapeuta humano?</h4>
                <p className="text-gray-700">No. SincronyBot es una herramienta complementaria que ofrece apoyo emocional inmediato, pero no sustituye la atención profesional de un psicólogo o terapeuta.</p>
              </div>
              <div>
                <h4 className="font-semibold text-lg">¿Es seguro compartir información con el bot?</h4>
                <p className="text-gray-700">Sí. Utilizamos cifrado de extremo a extremo para proteger tu información personal y emocional.</p>
              </div>
              <div>
                <h4 className="font-semibold text-lg">¿Puedo cancelar mi suscripción en cualquier momento?</h4>
                <p className="text-gray-700">Por supuesto. Puedes cancelar o cambiar tu plan desde tu perfil de usuario en cualquier momento.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contacto y Boletín */}
        <section className="bg-green-100 py-16 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6 text-gray-800">¿Tienes preguntas? Contáctanos</h2>
            <p className="mb-6 text-gray-700">Estamos aquí para ayudarte. Escríbenos y te responderemos lo antes posible.</p>
            <form className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <input className="p-3 rounded border" type="text" placeholder="Tu nombre" />
              <input className="p-3 rounded border" type="email" placeholder="Tu correo electrónico" />
              <textarea className="p-3 rounded border md:col-span-2" rows="4" placeholder="Tu mensaje" />
              <button className="bg-green-600 text-white py-2 px-6 rounded hover:bg-green-700 md:col-span-2">Enviar mensaje</button>
            </form>
          </div>
        </section>

        {/* Boletín de noticias */}
        <section className="bg-white py-12 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-2xl font-semibold mb-4">Suscríbete a nuestro boletín</h3>
            <p className="mb-6 text-gray-600">Recibe consejos, novedades y ofertas directamente en tu correo.</p>
            <form className="flex flex-col sm:flex-row justify-center gap-4">
              <input
                type="email"
                placeholder="Tu correo electrónico"
                className="p-3 rounded border w-full sm:w-auto"
              />
              <button className="bg-green-600 text-white py-2 px-6 rounded hover:bg-green-700">
                Suscribirme
              </button>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
